import React, {
    HTMLAttributes, ReactNode,
} from "react";
import Styles from "./ProgressBar.module.scss";
import Text from "../text/Text";

export interface ProgressBarProps extends HTMLAttributes<HTMLDivElement> {
    value: number;
    variant?: "progress" | "donut";
    shouldShowLabel?: boolean;
}

const ProgressBar = React.forwardRef((
    args: ProgressBarProps,
    ref: React.ForwardedRef<HTMLDivElement>,
): ReactNode => {
    const {
        variant,
        value,
        shouldShowLabel,
        ...rest
    } = args;

    if (variant === "progress") {
        return (
            <div className={Styles.progress}>
                <div
                    className="progress"
                    role="progressbar"
                    aria-label="Onboarding Progress"
                    aria-valuenow={0}
                    aria-valuemin={0}
                    aria-valuemax={100}
                >
                    <div className="progress-bar" nonce={window.NONCE} style={{ width: `${value * 100}%` }} />
                </div>
                {shouldShowLabel && (
                    <Text className={Styles.label} textVariant="body-2-medium" colorVariant="body-secondary">
                        {(value * 100).toFixed(0)}
                        %
                    </Text>
                )}
            </div>
        );
    }

    return (
        <div className={Styles[`progress-container`]} ref={ref} {...rest}>
            <svg
                viewBox="0 0 250 250"
                className={Styles[`progress-svg-${variant}`]}
                style={{ "--progress": value * 100 } as React.CSSProperties}
            >
                <circle className={Styles[`progress-svg-bg`]} />
                <circle className={Styles[`progress-svg-fg`]} />
            </svg>
            {shouldShowLabel && (
                <Text className={Styles.label} textVariant="body-2-medium" colorVariant="body-secondary">
                    {(value * 100).toFixed(0)}
                    %
                </Text>
            )}
        </div>
    );
});

ProgressBar.defaultProps = {
    shouldShowLabel: false,
};

export default ProgressBar;
